import {
  type PasswordStrengthLevel as BackendPasswordStrengthLevel,
  evaluatePasswordStrength as evaluateBackendPasswordStrength,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
} from '@gmn-portal/backend';

export { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH };

export type PasswordStrengthLevel = 'empty' | BackendPasswordStrengthLevel;

export interface PasswordStrengthResult {
  isAccepted: boolean;
  level: PasswordStrengthLevel;
  progress: number;
}

export function evaluatePasswordStrength(password: string): PasswordStrengthResult {
  if (!password) {
    return { level: 'empty', isAccepted: false, progress: 0 };
  }

  const level = evaluateBackendPasswordStrength(password);

  const progressByLevel: Record<BackendPasswordStrengthLevel, number> = {
    'too-short': 20,
    weak: 40,
    medium: 70,
    strong: 100,
  };

  return {
    level,
    isAccepted: level === 'medium' || level === 'strong',
    progress: progressByLevel[level],
  };
}
